var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-item"},[(_vm.isToggle)?_c('ElCollapse',{on:{"change":_vm.onToggle},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('ElCollapseItem',{attrs:{"name":"item"}},[_c('div',{class:[
          'inner',
          _vm.type,
          { 'is-toggle' : _vm.isToggle },
          { 'disabled' : _vm.disabled }
        ],attrs:{"slot":"title"},on:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}},slot:"title"},[_c('div',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.title)}}),_c('icon',{class:[
            'chevron-down',
            { 'open': _vm.localIsOpen }
          ],attrs:{"name":"chevron-down"}})],1),_c('div',{staticClass:"contents"},[_vm._t("default")],2)])],1):_c('RouterLink',_vm._b({attrs:{"data-test":"hamburger menu navigation"},nativeOn:{"click":function($event){return _vm.closeHamburgerMenu.apply(null, arguments)}}},'RouterLink',{
      class: [
        'inner',
        _vm.type,
        { 'link': !_vm.disabled },
        { 'is-toggle': _vm.isToggle },
        { 'disabled': _vm.disabled },
        { 'hover': _vm.hover },
      ],
      disabled: _vm.disabled,
      event: '', // disabling this to move logic to closeHamburgerMenu
      to: _vm.to,
    },false),[_c('div',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.title)}}),(_vm.icon)?_c('icon',{class:_vm.icon,attrs:{"name":_vm.icon}}):_vm._e(),(_vm.badgeCount)?_c('TfBadge',{attrs:{"value":_vm.badgeCount,"status":"error","is-counter":""}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }